import script from "./MonitorPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitorPlan.vue?vue&type=script&setup=true&lang=js"

import "./MonitorPlan.vue?vue&type=style&index=0&id=2cc4be23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc4be23"]])

export default __exports__